import { render } from "./SchoolEditHeader.vue?vue&type=template&id=446f1b66&scoped=true&ts=true"
import script from "./SchoolEditHeader.vue?vue&type=script&lang=ts"
export * from "./SchoolEditHeader.vue?vue&type=script&lang=ts"

import "./SchoolEditHeader.vue?vue&type=style&index=0&id=446f1b66&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446f1b66"]])

export default __exports__